import { BAR_CHART_HEIGHT, BAR_CHART_WIDTH } from 'entities/Charts/constants';
import {
  ChartFilterProps,
  useMisconceptionsChartData
} from 'entities/Charts/sdk';

import BarChart from 'components/BarChart';

const MisconceptionsBarChart = ({ filters }: { filters: ChartFilterProps }) => {
  const { data, isLoading } = useMisconceptionsChartData({ filters });

  return (
    <>
      {isLoading && (
        <BarChart
          loading
          series={[]}
          height={BAR_CHART_HEIGHT}
          width={BAR_CHART_WIDTH}
        />
      )}

      {!isLoading && (
        <BarChart
          dataset={data as readonly Record<string, any>[]}
          layout="horizontal"
          height={BAR_CHART_HEIGHT}
          width={BAR_CHART_WIDTH}
          localeText={{ noData: 'No data for selected filters' }}
          yAxis={[
            {
              dataKey: 'misconception_name',
              width: 250
            }
          ]}
          series={[{ dataKey: 'occurence_count', label: 'Count' }]}
          margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
        />
      )}
    </>
  );
};

export default MisconceptionsBarChart;
